import { StoryblokComponent, StoryblokComponentType } from '@storyblok/react'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

interface SearchSuggestionsProps {
  suggestions: string[]
  onSuggestionClick: (suggestion: string) => void
  categoriesBlok: StoryblokComponentType<any> | null
}

export function SearchSuggestions({
  suggestions,
  onSuggestionClick,
  categoriesBlok,
}: SearchSuggestionsProps) {
  const { t } = useTranslation()

  return (
    <div>
      <h2 className="text-xs text-gray-500 font-semibold mb-3 uppercase">
        {t('common:often_searched')}
      </h2>
      <div className="flex flex-wrap gap-2 mb-8">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion}
            onClick={() => onSuggestionClick(suggestion)}
            className="bg-gray-200 text-gray-800 px-3 py-1 rounded-full text-sm hover:bg-gray-300 transition-colors"
          >
            {suggestion}
          </button>
        ))}
      </div>
      <div>
        <h2 className="text-xs text-gray-500 font-semibold uppercase -mb-8">
          {t('common:categories')}
        </h2>
        <StoryblokComponent blok={categoriesBlok} />
      </div>
    </div>
  )
}
